import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getDisplayRating(rating: number | null | undefined, totalReviews: number | null | undefined) {
  const reviews = totalReviews || 0;
  if (reviews === 0) return { rating: 5.0, label: "New", reviews: 0, isDefault: true };
  return { rating: rating || 0, label: `${reviews} reviews`, reviews, isDefault: false };
}
